import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import styles from "../styles/_components/copyButton.module.scss";

const COPIED_FEEDBACK_MS = 1500;

// navigator.clipboard only exists in secure contexts and can be denied by the
// browser, so fall back to the legacy copy command.
const writeToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    const copied = document.execCommand("copy");
    document.body.removeChild(textarea);
    return copied;
  }
};

const CopyButton = ({ value, label }) => {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef(null);

  useEffect(() => () => clearTimeout(timeoutRef.current), []);

  const handleClick = async (e) => {
    // The number's wrapper opens the vehicle details modal on click.
    e.stopPropagation();
    const success = await writeToClipboard(String(value));
    if (!success) {
      toast.error("ההעתקה נכשלה");
      return;
    }
    setCopied(true);
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => setCopied(false), COPIED_FEEDBACK_MS);
  };

  return (
    <button
      type="button"
      className={`${styles.copyButton} ${copied ? styles.copied : ""}`}
      onClick={handleClick}
      title={copied ? "הועתק" : `העתקת ${label}`}
      aria-label={`העתקת ${label}`}
    >
      {copied ? (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M5 13l4 4L19 7" />
        </svg>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect x="9" y="9" width="11" height="11" rx="2" />
          <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
        </svg>
      )}
    </button>
  );
};

export default CopyButton;
